export default function PageHeader({ blok }) {
  return (
    <header className="px-8 mb-6 bg-heroBanner bg-left-top 2xl:bg-bottom bg-cover">
      <h1 className="max-w-screen-xl mx-auto break-words pt-16 lg:pt-20 min-h-[257px]">{blok.heading}</h1>
    </header>
  )
}
